<template>

    <trax-ui-card-testimonial :comments="comments" :user-name="userName" 
        :user-title="userTitle" :user-picture="userPicture">
    </trax-ui-card-testimonial>
    
</template>

<script>
    export default {

        data: function() {
            return {
                lang: lang,
                author: data.author,
                state: data.state,
            }
        },

        computed: {

            comments: function () {
                if (!this.state || !this.state.comments) return this.lang.polaris.dashboard.currently_no_comment;
                return this.state.comments;
            },

            userName: function () {
                if (!this.state || !this.state.validation) return null;
                return this.state.validation.user_name;
            },

            userTitle: function () {
            },

            userPicture: function () {
                return this.author ? this.author.avatar : null;
            }
        }
    }
</script>
